<template>
  <div class="customerMessage">
    <div class="avatar">
      <img style="width: 100%;height: 100%" class="visitor-img" :src="require('@/assets/img/customer-img.png')"/>
    </div>
    <div class="cont">
      <div class="name">{{$t('serviceSys')}}</div>
      <div class="message-cont">
        <div>{{$t('peakPeriod')}}</div>
        <div style="margin-top: 15px">{{queueTips}}</div>
        <div @click="get_queue" style="margin-top: 15px;color: red;cursor: pointer">{{$t('refreshQueue')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data () {
    return {}
  },
  computed: {
    ...mapState({
      queueTips: 'queueTips' // 排队提示
    })
  },
  methods: {
    ...mapActions({
      get_queue: 'get_queue'
    })
  }
}
</script>
<style scoped lang="less">
  .customerMessage{
    margin-top: 10px;
    display: flex;
    .avatar{
      width: 40px;
      height: 40px;
      border-radius: 50%;
      border: 1px solid #ddd;
    }
    .cont{
      padding-left: 10px;
      .message-cont{
        max-width: 400px;
        min-height: 30px;
        padding: 6px 10px;
        border-radius: 5px;
        background-color: #fff;
        margin-top: 5px;
        word-break: break-word;
      }
    }
    .withdraw{
      margin-top: 30px;
      margin-left: 10px;
    }
  }
</style>
